<template>

  <head>

    <meta charset="utf-8" />
    <title>NTSA | Users </title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  User Accounts category
                  <div v-if="loading.categories" class="loading-dots d-inline-block ml-2">
                    <span></span><span></span><span></span>
                  </div>
                </h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item active">User Accounts</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Toast Notifications -->
          <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
            <div v-if="message"
                 class="toast show align-items-center text-white border-0"
                 :class="messageType === 'success' ? 'bg-success' : 'bg-danger'"
                 role="alert"
                 aria-live="assertive"
                 aria-atomic="true">
              <div class="d-flex">
                <div class="toast-body">
                  <i :class="messageType === 'success' ? 'mdi mdi-check-circle me-2' : 'mdi mdi-alert-circle me-2'"></i>
                  {{ message }}
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="clearMessage" aria-label="Close"></button>
              </div>
            </div>
          </div>

          <!-- eTransactions table -->
          <div class="row">
            <div class="col-12">
              <div class="card modern-card" :class="{ 'loading-shimmer': loading.categories }">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">All User Accounts</h4>
                    <div class="d-flex">
                      <button v-if="getRight('CREATE USER CATEGORY')"
                              @click="addNewCategory"
                              type="button"
                              class="btn btn-primary btn-modern"
                              data-toggle="modal"
                              data-target=".create-account"
                              aria-controls="offcanvasRight"
                              :disabled="loading.categories">
                        <div class="btn-content">
                          <span v-if="loading.categories" class="spinner-modern"></span>
                          <i v-else class="mdi mdi-account-multiple-plus-outline font-size-16"></i>
                          <span class="pl-1 d-md-inline">Add Account Type</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white w-100 border-bottom d-flex">
                  <div class="mr-15px">
                    <select class="form-select form-control bg-white mr-15px modern-select"
                            title="Select System User Type"
                            data-live-search="true"
                            data-style="">
                      <option selected value="All users ({{ totalUsers }})">All users ({{ totalUsers }})</option>
                      <option value="Auditors [0]">Auditors [0]</option>
                      <option value="Accountants [2]">Accountants [2]</option>
                      <option value="ICT OFFICCERS">ICT OFFICERS</option>
                      <option value="ENFORCEMENT [0]">ENFORCEMENT [0]</option>
                    </select>
                  </div>

                  <div class="flex-grow-1">
                    <div class="search-box mb-0 me-2 flex-grow-1">
                      <div class="position-relative">
                        <input type="text"
                               class="form-control bg-light border-light rounded modern-input"
                               placeholder="Search User"
                               v-model="searchTerm">
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body position-relative">
                  <!-- Skeleton Loading for table -->
                  <div v-if="loading.categories" class="skeleton-container">
                    <div class="loading-message-container text-center mb-4">
                      <div class="loading-spinner-custom">
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                      </div>
                      <h5 class="loading-text">Please wait...</h5>
                      <p class="text-muted">Loading user categories</p>
                    </div>
                    <div class="table-responsive">
                      <table class="table align-middle table-nowrap table-hover">
                        <thead class="table-dark">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Account Category</th>
                          <th scope="col">Users</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="n in 5" :key="n" class="skeleton-row">
                          <td><div class="skeleton-text skeleton-short"></div></td>
                          <td><div class="skeleton-text skeleton-medium"></div></td>
                          <td><div class="skeleton-text skeleton-short"></div></td>
                          <td>
                            <div class="d-flex gap-2">
                              <div class="skeleton-button"></div>
                              <div class="skeleton-button"></div>
                              <div class="skeleton-button"></div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Actual Table content -->
                  <div v-else class="table-responsive fade-in">
                    <table class="table align-middle table-nowrap table-hover contacts-table table-striped modern-table">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Account Category</th>
                        <th scope="col">Users</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index"
                          :value="item"
                          v-for="(item, index) in filteredCategories"
                          class="table-row-hover"
                          :class="{ 'row-deleting': loading.delete === item.id }">
                        <th>{{index+1}}</th>
                        <td>
                          <div class="category-name">
                            {{item.category}}
                            <small v-if="loading.delete === item.id" class="text-muted d-block">Deleting...</small>
                          </div>
                        </td>
                        <th>
                          <span class="badge bg-primary rounded-pill">{{item.count}}</span>
                        </th>
                        <td class="text-right">
                          <div class="btn-group action-buttons" role="group">
                            <button v-if="getRight('DELETE USER CATEGORY')"
                                    @click="deleteCategories(item)"
                                    class="btn btn-sm btn-danger btn-modern"
                                    :disabled="loading.delete === item.id || loading.save">
                              <span v-if="loading.delete === item.id" class="spinner-modern-sm"></span>
                              <i v-else class="mdi mdi-delete-outline"></i>
                            </button>
                            <button v-if="getRight('EDIT USER CATEGORY')"
                                    @click="selectedCategory(item)"
                                    class="btn btn-sm btn-primary btn-modern"
                                    data-toggle="modal"
                                    data-target=".create-account"
                                    :disabled="loading.delete === item.id || loading.save">
                              <i class="mdi mdi-pencil-outline"></i>
                            </button>
                            <button @click="selectedCategory(item)"
                                    class="btn btn-sm btn-success btn-modern"
                                    data-toggle="modal"
                                    data-target=".create-account"
                                    :disabled="loading.delete === item.id || loading.save">
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="table-dark">
                        <th colspan="2">{{categories.length}} Accounts</th>
                        <th colspan="2">{{totalUsers}} Users</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Account creation privilages -->
      <div class="modal fade create-account " tabindex="-1 " role="dialog " aria-labelledby="transaction-detailModalLabel " aria-hidden="true ">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document ">
          <div class="modal-content modern-modal" :class="{ 'modal-loading': loading.roles }">
            <div class="modal-header border-bottom-0">
              <h5 class="modal-title d-flex align-items-center" id="transaction-detailModalLabel">
                <i class="mdi mdi-account-cog me-2 text-primary"></i>
                Account Category
                <div v-if="loading.roles" class="loading-dots ml-2">
                  <span></span><span></span><span></span>
                </div>
              </h5>
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal content with conditional loading -->
            <div class="modal-body position-relative">
              <!-- Loading overlay for modal content -->
              <div v-if="loading.roles" class="modal-skeleton">
                <div class="loading-message-container text-center mb-4">
                  <div class="loading-spinner-custom">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                  </div>
                  <h5 class="loading-text">Please wait...</h5>
                  <p class="text-muted">Loading roles and privileges</p>
                </div>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-8 mb-3">
                      <div class="skeleton-text skeleton-label"></div>
                      <div class="skeleton-text skeleton-input"></div>
                    </div>
                    <div class="col-12 mb-4">
                      <div class="skeleton-text skeleton-label"></div>
                      <div class="skeleton-text skeleton-select"></div>
                    </div>
                    <div class="col-6">
                      <div class="skeleton-text skeleton-medium mb-3"></div>
                      <div v-for="n in 4" :key="n" class="skeleton-checkbox mb-2"></div>
                    </div>
                    <div class="col-6">
                      <div class="skeleton-text skeleton-medium mb-3"></div>
                      <div v-for="n in 4" :key="n" class="skeleton-checkbox mb-2"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Actual modal content -->
              <div v-else class="container-fluid fade-in">
                <div class="row">
                  <div class="col-8">
                    <label for="" class="form-label fw-medium">Account Category Name</label>
                    <input v-model="category.category"
                           type="text"
                           class="form-control modern-input"
                           placeholder="Enter Category Name"
                           name=""
                           id=""
                           :disabled="loading.save">
                  </div>

                  <div class="col-12 mb-4">
                    <label for="" class="form-label fw-medium">Accessible platforms/Applications</label>
                    <select id="accessible-platforms"
                            name="fruits"
                            multiple
                            class="form-select modern-select"
                            :disabled="loading.save">
                      <option value="County Biller Dashboard">County Biller Dashboard</option>
                      <option value="Collections & Enforcement App">Collections & Enforcement App</option>
                      <option value="Supervision Mobile App">Supervision Mobile App</option>
                    </select>
                    <small class="text-muted">For multiple selections hold <strong>CTRL</strong> while selecting.</small>
                  </div>

                  <div class="col-12">
                    <h4 class="mb-3 section-title">
                      <i class="mdi mdi-monitor-dashboard me-2"></i>
                      Dashboard Rights & Privileges
                    </h4>
                  </div>

                  <div class="col-6 mb-4 dashboard-rights">
                    <label for="" class="form-label fw-medium text-primary">User management and Set ups</label>
                    <div class="privilege-group">
                      <div v-for="(role, index) in filteredDashboardRoles" :key="index" class="form-check mb-2 privilege-item">
                        <input
                            class="form-check-input modern-checkbox"
                            type="checkbox"
                            :id="'formCheck' + role.id"
                            :checked="isSelected(role)"
                            @change="toggleRoleSelection(role)"
                            :disabled="loading.save"
                        />
                        <label class="form-check-label privilege-label" :for="'formCheck' + role.id">{{ role.role }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 mb-4 dashboard-modules">
                    <label for="" class="form-label fw-medium text-success">Accessible Modules</label>
                    <div class="privilege-group">
                      <div class="form-check mb-2 privilege-item">
                        <input class="form-check-input modern-checkbox"
                               type="checkbox"
                               id="formCheck4"
                               :disabled="loading.save">
                        <label class="form-check-label privilege-label" for="formCheck4">
                          Dashboard
                        </label>
                      </div>

                      <div v-for="(role, index) in filteredModulesRoles" :key="index" class="form-check mb-2 privilege-item">
                        <input
                            class="form-check-input modern-checkbox"
                            type="checkbox"
                            :id="'formCheck' + role.id"
                            :checked="isSelected(role)"
                            @change="toggleRoleSelection(role)"
                            :disabled="loading.save"
                        />
                        <label class="form-check-label privilege-label" :for="'formCheck' + role.id">{{ role.role }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 mb-4 dashboard-modules">
                    <label for="" class="form-label fw-medium text-warning">Approvals</label>
                    <div class="privilege-group">
                      <div v-for="(role, index) in filteredActions" :key="index" class="form-check mb-2 privilege-item">
                        <input
                            class="form-check-input modern-checkbox"
                            type="checkbox"
                            :id="'formCheck' + role.id"
                            :checked="isSelected(role)"
                            @change="toggleRoleSelection(role)"
                            :disabled="loading.save"
                        />
                        <label class="form-check-label privilege-label" :for="'formCheck' + role.id">{{ role.role }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <h4 class="mb-3 section-title">
                      <i class="mdi mdi-cellphone me-2"></i>
                      Mobile App Rights & Privileges
                    </h4>
                  </div>

                  <div class="col-6 mb-4 enforcement-modules">
                    <label for="" class="form-label fw-medium text-info">Collections & Enforcement Platform</label>
                    <div class="privilege-group">
                      <div v-for="(role, index) in filteredMobileRoles" :key="index" class="form-check mb-2 privilege-item">
                        <input
                            class="form-check-input modern-checkbox"
                            type="checkbox"
                            :id="'formCheck' + role.id"
                            :checked="isSelected(role)"
                            @change="toggleRoleSelection(role)"
                            :disabled="loading.save"
                        />
                        <label class="form-check-label privilege-label" :for="'formCheck' + role.id">{{ role.role }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 mb-4 supervisor-modules">
                    <label for="" class="form-label fw-medium text-secondary">Supervision Platform</label>
                    <div class="privilege-group">
                      <div v-for="(role, index) in filteredSupervisoryRoles" :key="index" class="form-check mb-2 privilege-item">
                        <input
                            class="form-check-input modern-checkbox"
                            type="checkbox"
                            :id="'formCheck' + role.id"
                            :checked="isSelected(role)"
                            @change="toggleRoleSelection(role)"
                            :disabled="loading.save"
                        />
                        <label class="form-check-label privilege-label" :for="'formCheck' + role.id">{{ role.role }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer border-top-0">
              <button v-if="getRight('UPDATE USER CATEGORY')"
                      @click="updateCategories()"
                      class="btn btn-success btn-modern w-100"
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      :disabled="loading.save || loading.roles">
                <div class="btn-content">
                  <span v-if="loading.save" class="spinner-modern"></span>
                  <i v-else class="mdi mdi-content-save me-2"></i>
                  <span v-if="loading.save">Please wait... SAVING</span>
                  <span v-else>SAVE CHANGES</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of account privilages -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>
  </body>

</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, getRight} from "@/api";
import router from "@/router";
import NavigationBar from "@/components/Navigation";
export default {
  name: "SetAccounts",
  components: {NavigationBar},
  data() {
    return{
      totalUsers: 0,
      selectedRoles: [],
      searchTerm: '',
      category: {
        category: null,
        count: null,
        selectedRoles: null
      },
      categories: [],
      rights: [
        {
          type: {
            type: "ACTIONS"
          },
          roles: [
            {
              id: "60",
              type: "ACTIONS",
              role: "APPROVE SBP VALIDATION"
            },
            {
              id: "61",
              type: "ACTIONS",
              role: "APPROVE SBP INSPECTION"
            },
            {
              id: "62",
              type: "ACTIONS",
              role: "APPROVE SPB"
            }
          ]
        }],
      message: null,
      messageType: 'success',
      // Modern loading states
      loading: {
        categories: false,
        roles: false,
        save: false,
        delete: null,
      }
    }
  },
  computed: {
    filteredCategories() {
      if (!this.searchTerm) return this.categories;
      return this.categories.filter(category =>
          category.category?.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    filteredDashboardRoles() {
      return this.rights.flatMap((right) =>
          right.type.type === "DASHBOARD" ? right.roles : []
      );
    },
    filteredModulesRoles() {
      return this.rights.flatMap((right) =>
          right.type.type === "MODULES" ? right.roles : []
      );
    },
    filteredMobileRoles() {
      return this.rights.flatMap((right) =>
          right.type.type === "MOBILE" ? right.roles : []
      );
    },
    filteredSupervisoryRoles() {
      return this.rights.flatMap((right) =>
          right.type.type === "SUPERVISORY PLATFORM" ? right.roles : []
      );
    },
    filteredActions() {
      return this.rights.flatMap((right) =>
          right.type.type === "ACTIONS" ? right.roles : []
      );
    },
  },
  mounted() {
    this.initializePage();
  },
  methods: {
    async initializePage() {
      await this.menuAccess();
      await Promise.all([this.getRoles(), this.getCategories()]);
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Set Accounts");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));

      return execute(data, biller);
    },

    getRight(type){
      return getRight(type)
    },

    selectedCategory(category) {
      this.selectedRoles.splice(0);
      this.category = category;
      this.selectedRoles = Array.isArray(category.selectedRoles) ? category.selectedRoles : JSON.parse(category.selectedRoles || '[]');
    },

    toggleRoleSelection(role) {
      const index = this.selectedRoles.findIndex(selectedRole => selectedRole.id === role.id);

      if (index === -1) {
        this.selectedRoles.push(role);
      } else {
        this.selectedRoles.splice(index, 1);
      }
    },

    isSelected(role) {
      return this.selectedRoles.some(selectedRole => selectedRole.id === role.id);
    },

    addNewCategory() {
      this.category = {
        selectedRoles: null,
        category: null,
        count: null
      };
      this.selectedRoles.splice(0);
    },

    showMessage(message, type = 'success') {
      this.message = message;
      this.messageType = type;
      setTimeout(() => {
        this.clearMessage();
      }, 4000);
    },

    clearMessage() {
      this.message = null;
    },

    getRoles(){
      this.loading.roles = true;

      const data = new FormData();
      data.append("function", "getRoles");

      return execute(data, authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.rights = res.data.data.rights;
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to load roles', 'error');
          })
          .finally(() => {
            this.loading.roles = false;
          });
    },

    getCategories(){
      this.loading.categories = true;
      this.categories.splice(0);

      const data = new FormData();
      data.append("function", "getCategories");

      return execute(data, authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.categories = res.data.data.categories;
              this.totalUsers = this.categories.reduce((sum, category) => sum + parseInt(category.count), 0);
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to load categories', 'error');
          })
          .finally(() => {
            this.loading.categories = false;
          });
    },

    updateCategories(){
      this.loading.save = true;

      const data = new FormData();
      data.append("function", "updateCategories");
      data.append("category", JSON.stringify(this.category));
      data.append("selectedRoles", JSON.stringify(this.selectedRoles));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.getCategories();
              this.showMessage('Category updated successfully! 🎉', 'success');
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to update category', 'error');
          })
          .finally(() => {
            this.loading.save = false;
          });
    },

    deleteCategories(category) {
      const userConfirmed = window.confirm("Are you sure you want to delete this category?");

      if (!userConfirmed) return;

      this.loading.delete = category.id;
      this.selectedRoles.splice(0);
      this.category = category;
      this.selectedRoles = Array.isArray(category.selectedRoles)
          ? category.selectedRoles
          : JSON.parse(category.selectedRoles || '[]');

      const data = new FormData();
      data.append("function", "deleteCategories");
      data.append("category", JSON.stringify(this.category));
      data.append("selectedRoles", JSON.stringify(this.selectedRoles));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.getCategories();
              this.showMessage('Category deleted successfully! 🗑️', 'success');
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to delete category', 'error');
          })
          .finally(() => {
            this.loading.delete = null;
          });
    }
  }
}
</script>

<style scoped>
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Modern Card Styling */
.modern-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.modern-card:hover {
  box-shadow: 0 8px 35px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

/* Modern Button Styling */
.btn-modern {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  position: relative;
  overflow: hidden;
}

.btn-modern:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.btn-modern .btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modern Input Styling */
.modern-input, .modern-select {
  border-radius: 8px;
  border: 1px solid #e3e6f0;
  transition: all 0.3s ease;
  padding: 12px 16px;
}

.modern-input:focus, .modern-select:focus {
  border-color: #4e73df;
  box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.15);
  transform: translateY(-1px);
}

/* Modern Table Styling */
.modern-table {
  border-radius: 8px;
  overflow: hidden;
}

.table-row-hover {
  transition: all 0.3s ease;
}

.table-row-hover:hover {
  background-color: rgba(78, 115, 223, 0.05);
  transform: scale(1.01);
}

.row-deleting {
  opacity: 0.6;
  background-color: rgba(220, 53, 69, 0.1);
}

/* Action Buttons */
.action-buttons .btn {
  margin: 0 2px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Modern Checkbox Styling */
.modern-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #ddd;
  transition: all 0.3s ease;
}

.modern-checkbox:checked {
  background-color: #4e73df;
  border-color: #4e73df;
  transform: scale(1.1);
}

/* Privilege Groups */
.privilege-group {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #4e73df;
}

.privilege-item {
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.privilege-item:hover {
  background-color: rgba(78, 115, 223, 0.05);
}

.privilege-label {
  margin-left: 8px;
  font-weight: 500;
}

/* Section Titles */
.section-title {
  color: #5a5c69;
  font-weight: 600;
  border-bottom: 2px solid #eaecf4;
  padding-bottom: 8px;
}

/* Loading Animations */
.loading-dots {
  display: inline-flex;
  align-items: center;
}

.loading-dots span {
  width: 4px;
  height: 4px;
  margin: 0 1px;
  background: #4e73df;
  border-radius: 50%;
  animation: loading-dots 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }

@keyframes loading-dots {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Modern Spinner */
.spinner-modern {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

.spinner-modern-sm {
  width: 12px;
  height: 12px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Skeleton Loading */
.skeleton-container {
  animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-text, .skeleton-button, .skeleton-checkbox {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
}

.skeleton-short { width: 60px; height: 20px; }
.skeleton-medium { width: 120px; height: 20px; }
.skeleton-input { width: 100%; height: 42px; border-radius: 8px; }
.skeleton-select { width: 100%; height: 38px; border-radius: 6px; }
.skeleton-button { width: 32px; height: 32px; border-radius: 50%; }
.skeleton-label { width: 80px; height: 14px; margin-bottom: 8px; }
.skeleton-checkbox { width: 200px; height: 18px; margin-bottom: 8px; }

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-row {
  opacity: 0.7;
}

/* Modal Styling */
.modern-modal {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.modal-skeleton {
  opacity: 0.7;
}

/* Toast Notifications */
.toast {
  border-radius: 10px;
  backdrop-filter: blur(10px);
  animation: slideInRight 0.4s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Fade In Animation */
.fade-in {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Category Name Styling */
.category-name {
  font-weight: 500;
}

/* Badge Styling */
.badge {
  font-size: 12px;
  padding: 6px 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .action-buttons .btn {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .modern-card {
    margin-bottom: 1rem;
  }

  .privilege-group {
    padding: 12px;
  }
}
</style>